export default class Search {
    constructor(elm) {
        this.searchContainer = elm.querySelector('.search-result-container');
        this.resultAmountFirst = elm.querySelector('.result-amound--first');
        this.resultAmountSecond = elm.querySelector('.result-amound--second');

        this.resultBottom = elm.querySelector(
            '.header__search-container__bottom',
        );

        this.abortController = new AbortController();

        this.searchInput = elm.querySelector('#search');
        const searchCallback = this.loadSearchResult.bind(this);
        const abortCallback = this.abortFetch.bind(this);

        this.searchInput.onkeyup = function () {
            const searchInputValue = this.searchInput.value;
            if (searchInputValue.length > 2) {
                abortCallback();
                searchCallback(searchInputValue);
            }
        }.bind(this);
    }

    async loadSearchResult(searchString) {
        const signal = this.abortController.signal;
        const url =
            '/umbraco/api/search/content?query=' +
            searchString +
            '&culture=da&html=true';
        try {
            const response = await fetch(url, {
                signal,
            });
            const value = await response.json();
            this.searchContainer.innerHTML = value.htmlResults;
            this.resultAmountFirst.innerHTML = value.totalResults;
            this.resultAmountSecond.innerHTML = value.totalResults;
            this.resultBottom.style.display = 'flex';
        } catch (error) {
            if (typeof error !== DOMException && error.name !== 'AbortError') {
                console.error(error);
            }
        }
    }

    abortFetch() {
        this.abortController?.abort();
        this.fetchIsLoading = false;
        this.abortController = new AbortController();
    }

    clearResults() {
        console.log(this.searchInput);
        this.searchInput.value = '';
        this.searchContainer.innerHTML = '';
        this.resultAmountFirst.innerHTML = 0;
        this.resultAmountSecond.innerHTML = 0;
        this.resultBottom.style.display = 'none';
    }
}
